import LocaleLink from "views/components/LocaleLink";

const NoData = ({ title, subtitle, cta, children, headingLevel: HeadingLevel = "h1" }) => {
	return (
		<section className="py-5" data-testid="noData">
			<div className="container">
				<div className="row gy-3 justify-content-center">
					<div className="col-12 mt-0">
						<div className="row justify-content-center">
							<div className="col-auto">
								<div className="d-flex align-items-center justify-content-center text-secondary">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="48"
										height="48"
										fill="currentColor"
										viewBox="0 0 16 16">
										<path d="M6.002 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm.195-12.01a1.81 1.81 0 1 1 3.602 0l-.701 7.015a1.105 1.105 0 0 1-2.2 0l-.7-7.015z" />
									</svg>
								</div>
							</div>
						</div>
					</div>
					<div className="col-12">
						{subtitle && <p className="mb-0 lean text-capitalize text-center text-secondary">{subtitle}</p>}
						<HeadingLevel className="text-uppercase text-center text-secondary" data-testid="noDataTitle">
							<strong>{title || "no data found"}</strong>
						</HeadingLevel>
					</div>
					{cta ? (
						<>
							<div className="col-12 col-sm-10 col-md-8">
								{cta?.method || (cta?.toggle && cta?.target) ? (
									<button
										type="button"
										onClick={cta?.method}
										className="btn btn-outline-primary w-100 text-uppercase"
										disabled={cta?.disabled}
										aria-hidden={cta?.disabled ? "true" : undefined}
										tabIndex={cta?.disabled ? "-1" : undefined}
										data-bs-target={cta?.target}
										data-bs-toggle={cta?.toggle}
										data-testid="noDataCTA">
										<strong>
											<small>{cta?.text}</small>
										</strong>
									</button>
								) : (
									<>
										<LocaleLink
											to={cta?.to || "/"}
											className={`btn btn-outline-primary w-100 text-uppercase ${
												cta?.disabled ? "disabled" : ""
											}`}
											aria-hidden={cta?.disabled ? "true" : undefined}
											tabIndex={cta?.disabled ? "-1" : undefined}
											data-testid="noDataCTA">
											<strong>
												<small>{cta?.text}</small>
											</strong>
										</LocaleLink>
									</>
								)}
							</div>
							{cta?.description ? (
								<div className="col-12 col-sm-10 col-md-8 mt-0">
									<p className="small mb-0 text-center" data-testid="noDataDescription">
										<small>{cta?.description}</small>
									</p>
								</div>
							) : (
								<></>
							)}
						</>
					) : (
						<></>
					)}
					<div className="col-12">{children}</div>
				</div>
			</div>
		</section>
	);
};

export default NoData;
